/**
 * Centralized session flag: user has unsaved edits and navigation should confirm.
 * (Previously scattered as sessionStorage key "showAppAlert".)
 */
export const SHOW_APP_ALERT_STORAGE_KEY = 'showAppAlert'

function readShowAppAlertFlagRaw() {
  if (typeof sessionStorage === 'undefined') return false
  try {
    // Storage contract: value is serialized boolean.
    const raw = sessionStorage.getItem(SHOW_APP_ALERT_STORAGE_KEY)
    if (raw == null || raw === '') return false
    return JSON.parse(raw) === true
  } catch {
    return false
  }
}

/**
 * Persists unsaved-navigation state. Skips sessionStorage writes when the value is unchanged
 * (e.g. user dismissed the unsaved popup but the form is still dirty — avoids redundant setItem).
 *
 * @param {boolean} enabled Desired unsaved-navigation guard state.
 * @returns {void}
 */
export function setShowAppAlertFlag(enabled) {
  if (typeof sessionStorage === 'undefined') return
  const next = !!enabled
  if (readShowAppAlertFlagRaw() === next) return
  sessionStorage.setItem(SHOW_APP_ALERT_STORAGE_KEY, JSON.stringify(next))
}

export function clearShowAppAlertFlag() {
  setShowAppAlertFlag(false)
}

/**
 * Same truthiness as legacy `sessionStorage.showAppAlert && JSON.parse(sessionStorage.showAppAlert)`.
 *
 * @returns {boolean} True when unsaved navigation warning is active.
 */
export function hasPendingUnsavedNavigation() {
  if (typeof sessionStorage === 'undefined') return false
  return readShowAppAlertFlagRaw() === true
}
